import { Sprite, Texture, Graphics, Text, TextMetrics } from 'pixi.js';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { getCurrencySymbol } from '../helper/currencies';
import { EVENTS } from '../../lib/constants';
import QuestData from './helper/getQuestData';

const items = [
	{
		id: 0,
		name: '10',
		img: 'quest_ten'
	},
	{
		id: 1,
		name: 'J',
		img: 'quest_j'
	},
	{
		id: 2,
		name: 'Q',
		img: 'quest_q'
	},
	{
		id: 3,
		name: 'K',
		img: 'quest_k'
	},
	{
		id: 4,
		name: 'A',
		img: 'quest_ace'
	},
	{
		id: 5,
		name: 'Telescope',
		img: 'quest_telescope'
	},
	{
		id: 6,
		name: 'Helmet',
		img: 'quest_helmet'
	},
	{
		id: 7,
		name: 'Asteroid',
		img: 'quest_asteroid'
	},
	{
		id: 8,
		name: 'Starship',
		img: 'quest_starship'
	},
	{
		id: 9,
		name: 'Alien',
		img: 'quest_alien'
	}
];

class QuestItemController {
	constructor(vc, conf) {
		this.config = conf;
		this.all_quest = QuestData.processQuest(GameConfigs.quest);
		this.quest_data = this.all_quest.items[this.config.id - 1];
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
		this.positions = {
			width: window.isMobile || window.isTablet ? 317 : 317,
			x: window.isMobile || window.isTablet ? 140 : 140,
			y: window.isMobile || window.isTablet ? 80 : 80
		};
		if (vc.getChildByName(this.config.item, true)) {
			this.vc = vc.getChildByName(this.config.item, true);
			this.generateItemData(this.quest_data);
			this.init();
			window.addEventListener(EVENTS.SERVER_MSG, this, false);
			window.addEventListener(EVENTS.MODAL, this, false);
		} else {
			throw new Error(
				'QuestItemController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.SERVER_MSG:
				if (evt.detail.service === 'quest') {
					this.all_quest = QuestData.processQuest(GameConfigs.quest);
					this.quest_data = this.all_quest.items[this.config.id - 1];
					this.quest_data.progress =
						evt.detail.data.progresses[this.config.id - 1];
					this.quest_data.item.isCompleted =
						evt.detail.data.progresses[this.config.id - 1] >=
						this.quest_data.item.count;
					this.checkComplete(this.quest_data.item.isCompleted);
				}

				break;
			case 'modal':
				if (evt.detail.modal !== 'quest') {
					window.removeEventListener(EVENTS.SERVER_MSG, this, false);
					window.removeEventListener(EVENTS.MODAL, this, false);
				}
				break;
			default:
				break;
		}
	}

	checkComplete(completed) {
		if (completed) {
			this.vc.itemprogresstext.text = 'COMPLETED';
			this.drawRectangle(
				this.vc.itemprogressresult,
				this.positions.x,
				this.positions.y,
				this.positions.width,
				16,
				0.3 * this.positions.width
			);
		} else {
			this.updateProgress();
		}
	}

	init() {
		this.vc.itemheader.tint = this.config.color;
		this.vc.itemprogress = new Graphics();
		this.vc.itemprogress.clear();
		this.vc.itemprogress.beginFill(0x1d0c2c);
		this.vc.itemprogress.drawRoundedRect(
			this.positions.x,
			this.positions.y,
			this.positions.width,
			16,
			12
		);
		this.vc.itemprogresstext = new Text('', {
			fontSize: 14,
			fontFamily: 'Poppins SemiBold',
			fill:
				this.quest_data.item.count / this.quest_data.progress < 2
					? '#230E35'
					: '#DEE0EF'
		});
		this.vc.itemprogressresult = new Graphics();
		this.initPositions();
		this.checkComplete(this.quest_data.isCompleted);
	}

	initPositions() {
		this.vc.itemimg.position.x = 6;
		this.vc.itemimg.position.y = 6;
		this.vc.itemprogresstext.anchor.x = 0.5;
		this.vc.itemprogresstext.position.x =
			this.positions.x + this.vc.itemprogress.getBounds().width / 2;
		this.vc.itemprogresstext.y = 80;
		this.vc.addChild(this.vc.itemprogress);
		this.vc.itemprogress.addChild(this.vc.itemprogressresult);
		this.vc.itemprogress.addChild(this.vc.itemprogresstext);
	}

	drawRectangle(vc, x, y, w, h, r) {
		vc.clear();
		vc.beginFill(
			this.quest_data.progress >= this.quest_data.item.count
				? 0xa2af50
				: 0xe5a7dd
		);
		vc.drawRoundedRect(x, y, w, h, r);
	}

	updateProgress() {
		if (this.quest_data.isCompleted) return;
		this.vc.itemprogresstext.style.fill =
			this.quest_data.item.count / this.quest_data.progress < 2
				? '#230E35'
				: '#DEE0EF';
		this.vc.itemprogresstext.text =
			this.quest_data.progress + '/' + this.quest_data.item.count;
		this.drawRectangle(
			this.vc.itemprogressresult,
			this.positions.x,
			this.positions.y,
			(this.positions.width / this.quest_data.item.count) *
				this.quest_data.progress,
			16,
			0.3 *
				((this.positions.width / this.quest_data.item.count) *
					this.quest_data.progress)
		);
	}

	capitalizeWords(str) {
		return str
			.split(' ')
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	}

	generateItemData(data) {
		this.generateItem(data);
		this.generatePrize(data);
	}

	generateItem(data) {
		switch (data.item.type) {
			case 'line_count':
				//TODO get dynamic img
				this.vc.itemimg = new Sprite(
					Texture.from(items[data.item.config.item_id].img)
				);
				this.vc.addChild(this.vc.itemimg);
				this.vc.itemheader.text = `Catch ${data.item.config.count}x ${items[data.item.config.item_id].name} Symbol`;
				break;
			case 'total_count':
				this.vc.itemimg = new Sprite(Texture.from('quest_item_icon_2'));
				this.vc.addChild(this.vc.itemimg);
				this.vc.itemheader.text = `Catch Min. ${data.item.config.count}x Scatter`;
				break;
			case 'coeff':
				this.vc.itemimg = new Sprite(Texture.from('quest_item_icon_3'));
				this.vc.addChild(this.vc.itemimg);
				this.vc.itemheader.text = `Catch +${data.item.config.coeff}x Multiplier`;
				break;
			case 'wager':
				this.vc.itemimg = new Sprite(Texture.from('quest_item_icon_4'));
				this.vc.addChild(this.vc.itemimg);
				if (this.currency[1] === 'left') {
					this.vc.itemheader.text = `Spin ${this.currency[0]}${GameConfigs.config.bet_steps[data.item.config.bet_level]}+ Bet Amount`;
				} else {
					if (GameConfigs.auth.balance.currency === 'GEL') {
						this.vc.itemheader.text = `Spin ${GameConfigs.config.bet_steps[data.item.config.bet_level]}${this.currency[0]}+ Bet Amount`;
					} else {
						this.vc.itemheader.text = `Spin ${GameConfigs.config.bet_steps[data.item.config.bet_level]} ${this.currency[0]}+ Bet Amount`;
					}
				}
				break;
			default:
				break;
		}
		const item_header_coeff = TextMetrics.measureText(
			this.vc.itemheader.text,
			this.vc.itemheader.style
		);
		if (item_header_coeff.width > 330) {
			this.vc.itemheader.style.fontSize = 20;
		} else {
			this.vc.itemheader.style.fontSize = 24;
		}
	}

	generatePrize(data) {
		let prize = data.prize;
		let prize_type = this.capitalizeWords(prize.type.split('_').join(' '));

		switch (data.prize.type) {
			case 'bonus_discount':
				this.vc.itemsubtitle.text = 'Bet Relevant';
				this.vc.itemdesc.text = `${prize.config.discount}% ${prize_type}`;
				const bonus_discount = TextMetrics.measureText(
					this.vc.itemsubtitle.text,
					this.vc.itemsubtitle.style
				);
				this.vc.itemdesc.x = 175 + bonus_discount.width;
				break;
			case 'bonus_game':
				this.vc.itemsubtitle.text = 'Bet Relevant Free';
				const bonus_game = TextMetrics.measureText(
					this.vc.itemsubtitle.text,
					this.vc.itemsubtitle.style
				);
				this.vc.itemdesc.x = 175 + bonus_game.width;
				this.vc.itemdesc.text = prize_type;
				break;
			case 'bet_discount':
				this.vc.itemsubtitle.text = 'Bet Relevant';
				this.vc.itemdesc.text = `${prize.config.discount}% ${prize_type}`;
				const bet_discount = TextMetrics.measureText(
					this.vc.itemsubtitle.text,
					this.vc.itemsubtitle.style
				);
				this.vc.itemdesc.x = 175 + bet_discount.width;
				break;
			case 'win_multiplier':
				this.vc.itemsubtitle.text = 'Bet Relevant';
				this.vc.itemdesc.text = `${prize.config.multiplier}X ${prize_type}`;
				const win_multipluer = TextMetrics.measureText(
					this.vc.itemsubtitle.text,
					this.vc.itemsubtitle.style
				);
				this.vc.itemdesc.x = 175 + win_multipluer.width;
				break;
			case 'wild_respin':
				this.vc.itemsubtitle.text = 'Bet Relevant';
				this.vc.itemdesc.text = `${prize.config.wilds}x ${prize_type}`;
				const wager = TextMetrics.measureText(
					this.vc.itemsubtitle.text,
					this.vc.itemsubtitle.style
				);
				this.vc.itemdesc.x = 175 + wager.width;
				break;
			default:
				break;
		}
	}
}

export default QuestItemController;
